import c from 'classnames';
import { NodeSpec } from 'prosemirror-model';

import { BaseExtension } from '@lyearn/lygo-core';

import { calloutBlocksByKey, CalloutBlockTypeEnum, NODE_NAME } from './consts';
import plugins from './plugins';
import { calloutContainerStyles, calloutTextStyles } from './styles';

export default class Callout extends BaseExtension {
  get schema(): NodeSpec {
    return {
      attrs: {
        type: {
          default: CalloutBlockTypeEnum.SolidBlack,
        },
        id: { default: null },
      },
      content: 'inline*',
      group: 'block',
      isAtom: true,
      parseDOM: [
        {
          tag: 'div.calloutContainer',
          getAttrs: (element) => {
            return { type: (element as HTMLElement).dataset.type };
          },
        },
      ],
      toDOM: (node) => {
        const { type = CalloutBlockTypeEnum.SolidBlack } = node.attrs;
        const { background, textColor } = calloutBlocksByKey[type];
        return [
          'div',
          {
            class: c('my-56 calloutContainer', calloutContainerStyles(textColor)),
            'data-type': type,
            id: node.attrs.id,
          },
          [
            'p',
            {
              class: c('heading-s py-40 rounded callout', calloutTextStyles),
              style: `
background: ${background};
caret-color: ${textColor || 'var(--text-white)'};`,
            },
            0,
          ],
        ];
      },
    };
  }

  get name(): string {
    return NODE_NAME;
  }

  plugins = plugins;
}
